import { capitalize } from "src/utils";

const isFn = fn => fn && typeof fn === "function";

// Logs paintInfo event metrics
export const paintInfo = () => {
  if (isFn(window.__perf)) {
    const [firstPaint = {}, firstContentfulPaint = {}] = performance.getEntriesByType("paint");

    window.__perf("Paint", "first", firstPaint.startTime);
    window.__perf("Paint", "firstContentful", firstContentfulPaint.startTime);
  }
};

// Logs appInitialized events
export const appInitialized = () => {
  if (isFn(window.__perf)) {
    const now = performance.now();
    window.__perf("App", "initialized", now);
  }
};

// Logs componentMounted events for the component name and props
export const componentMounted = (name, props, pre) => {
  if (isFn(window.__perf)) {
    const now = performance.now();

    const post = name === "adUnit" ? props.dfpAdUnitId : name === "customComponent" ? props.componentName : null;

    let id = name;
    id = post != undefined ? `${id}_${post}` : id;
    id = pre != undefined ? `${pre}_${capitalize(id)}` : id;

    window.__perf(id, "mounted", now);
  }
};
